<!--
/*******************************************************************************
*@ 컴포넌트명   : Default.vue
*@ 컴포넌트설명 : selectbox - option에 사용되는 template
*@ 사용전문     :
********************************************************************************
** 날짜/시      작성자   변경내역
********************************************************************************
** 
********************************************************************************/
-->
<template>
  <div>
    <slot name="text" />
  </div>
</template>
<script>
export default {};
</script>